export default {
  // GeneralReport
  reportsTitle: 'Reports',
  reportsSubtitle: 'Learning outcomes tracking system',
  selectReportType: 'Select the Report Type',
  selectReportTypePlaceholder: '-- Select a report type --',
  configureFilters: 'Configure specific filters for the selected report',
  generateReport: 'Generate Report',
  clearFilters: 'Clear Filters',
  welcomeMessage: 'Welcome {firstName} {lastName}',
  welcomeDescription: 'In the Reports System you can access different types of reports on learning outcomes tracking. Among all available reports, some examples are:',
  generatingReport: 'Generating Report...',
  pleaseWait: 'Please wait while the report is being generated.',
  noEgressProfileCompetencesTooltip: 'The selected {egressProfile} has no linked {competences}, so this report cannot be generated.',

  // Report Types
  assessmentByMatter: 'Assessment Report by {matter} of {egressProfile}',
  assessmentByCompetence: 'Assessment Report by {competences} of {egressProfile}',
  assessmentGroupCompetence: 'Group Assessment Report of {competences} achievements of {egressProfile}',
  assessmentGroupRaMicro: 'Group Assessment Report of {raMicro} achievements by {matter}',
  assessmentGroupCriteria: 'Group Assessment Report of {evaluationCriteria} achievements by {matter}',
  averageGradesReport: 'Average Grades of {egressProfile} by Levels and Ranges',
  progressionReport: 'Progression Report of {evaluations}',
  reportIndividualGrades: 'Report of individual grades by {matter}',

  // Filters
  admissionYear: 'Admission Year',
  cohortIndex: 'Cohort Index',
  level: 'Level',
  modality: 'Modality',
  progression: 'Progression',
  periodType: 'Type of {period}',
  teachers: 'Teachers',
  currentPeriods: 'Current {periods}',
  pastPeriods: 'Past {periods}',
  inRegime: 'In Regime',
  notInRegime: 'Not in Regime',
  regime: 'Regime',
  declaredCohort: 'Declared cohort',
  expectedLevel: 'Expected level',
  stagePrevious: 'previous',
  stageCurrent: 'current',
  stageFuture: 'future',
  gradeApproved: 'approved',
  gradeFailed: 'failed',
  gradeInProgress: 'in progress',

  // AchievementExplanationBadge
  achievementCalculation: 'Achievement calculation',
  summativeAchievement: 'Summative achievement',
  formativeAchievement: 'Formative achievement',
  sectionSelected: 'considered',
  sectionDiscarded: 'not considered',
  contributes: 'contributes',
  notConsideredNoAchievement: 'no achievement, not considered',
  notConsideredNoWeight: 'weight 0, not considered',
  itemQuestion: 'Question',
  points: 'pts',

  // TagSelector
  requiredFieldTooltip: 'You must select at least one item.',
  clearSelectedTooltip: 'Clear selected items.',
  noOptionsAvailable: 'Nothing to select.',
  year: 'Year',

  // AssessmentRangeSection
  assessmentReportBy: 'ASSESSMENT REPORT BY {entity}',

  // AchievementRangeGroupSelector
  selectAchievementRange: 'Select achievement range:',

  // AssessmentRangeTable
  formative: 'FORMATIVE',
  summative: 'SUMMATIVE',
  visualizeColumns: 'Display columns',
  reportXlsx: 'XLSX Report',
  reportCompetenceXlsx: 'Report of {competences}',
  number: 'N°',
  lastName: 'Last Name',
  firstName: 'First Name',
  identifier: 'IDENTIFIER',
  admissionYearUpper: 'ADMISSION YEAR',
  grade: 'GRADE',
  finalGradeTooltip: 'Final Grade of the {matter}',
  name: 'Name',
  range: 'RANGE',
  achievementRanges: 'ACHIEVEMENT RANGES',
  assessmentReportByMatterEgressProfile: 'ASSESSMENT REPORT BY EGRESS PROFILE MATTER',
  numberOfStudents: 'Number of Students',
  assessment: 'Assessment',

  // TeacherInfoTable
  teachersUpper: 'TEACHER(S)',

  // AssessmentRangeSelector
  expectedLearning: 'Expected Learning:',

  // AssessmentCompetenceEgrProTable
  assessmentReportByCompetenceEgressProfile: 'Assessment report by {competences} of the egress profile',
  inRegimeStudentsOnly: 'This table applies only to students',
  completed: 'Completed',
  inProgress: 'In Progress',
  pending: 'Pending',
  legendOf: 'Legend of',
  ofThePlan: 'of the plan',

  // AssessmentGroupCompEgrProTable
  tributationOf: 'Contribution of',
  noRecord: 'No record',
  totalStudents: 'Total students',
  quantity: 'Quantity',
  percentageSymbol: '%',
  averageAchievementOfMatter: 'Average achievement of the {matter}',
  total: 'Total',
  assessmentGroupCompetenceReportTitle: 'Group assessment report of {competences} achievements of {egressProfile}',

  // AssessmentGroupStudyUnitTable
  assessmentGroupRaMicroReportTitle: 'Group assessment report of {raMicro} achievements of {egressProfile}',
  assessmentGroupRaMicroByMatterReportTitle: 'Group assessment report of {raMicro} achievements by {matter}',
  selectSection: 'Select a Section',
  viewAll: 'View all {assessmentType}',
  quantityPercentage: 'Quantity/Percentage',
  cant: 'Qty',
  percentage: 'Percentage',
  noDataToDisplay: 'No data to display',

  // AssessmentGroupEvaluationCriteriaTable
  assessmentGroupEvaluationCriteriaReportTitle: 'Group assessment report of {evaluationCriteria} achievements by {matter}',
  raCe: 'RA - EC',
  statement: 'Statement',
  noRange: 'No range',
  selectPeriod: 'Select a Period',
  viewAllAssessments: 'View all Assessments',
  competenceUnitNumber: 'CU No.',
  evaluationInProgress: 'Evaluation in Progress...',

  // GradeRangeGroupSelector
  selectGradeRange: 'Select grade range',

  // EvaluationGradeReportTable
  averagesByMatterTitle: 'Averages by {matter} of {egressProfile} by ranges and levels',
  gradeRanges: 'Grade ranges',
  rangePercentage: 'Range (%)',
  averageGradesByEgressProfileTitle: 'Average grades of {egressProfile} by levels and ranges',
  viewAllLevels: 'View all Levels',

  // ProfessorProgressionReportTable
  progressionReportTitle: 'Progression report of {evaluations}',
  evaluationType: '{evaluation} type',
  professors: 'Professors',
  studentsStarted: 'Students who started',
  studentsStartedNotFinished: 'Students who started but did not finish',
  studentsFinished: 'Students who finished',
  studentsGradePublished: 'Students with published grade',
  navigation: 'Navigation',
  sectionGrades: '{section} grades',
  sectionEvaluations: '{section} {evaluations}',
  noSectionsFoundWithFilters: 'No sections found with the applied filters.',

  // TagSelectorWithPagination
  searchPlaceholder: 'Search {title}...',
  loading: 'Loading {title}...',
  noResultsFound: 'No {title} found with "{search}"',
  typeToFilter: 'Type to filter {title}...',
  previous: 'Previous',
  next: 'Next',
  loadingError: 'Error loading users',

  // IndividualMatterGradesReportTable
  individualGradesBy: 'individual grades by',
  of: 'of',
  gradeHistoryIn: 'grade history in',
  current: 'current',
  cohort: 'cohort',
  byLevelsAndRanges: 'by levels and ranges',
  problemGeneratingReport: 'There was a problem generating the report.',
}
